import { ADDRESS_HANDLER_KEYS } from 'components/modules/Insurance/components/Policyholder/Policyholder.constants';
import { FIELDS } from 'store/insuranceAnketa/constants';

export const NAMES = {
  BIRTH_PLACE: 'birthPlace',

  LIVING_ADDRESS: 'livingAddress',
  LIVING_ADDRESS_EQUALS: 'livingAddressEquals',
  LIVING_ADDRESS_FROM_DA_DATA: 'livingAddressFromDaData',

  MANUAL_LIVING_ADDRESS: 'manualLivingAddress',
  MANUAL_REGISTRATION_ADDRESS: 'manualRegistrationAddress',

  PASSPORT_CHANGED: 'passportChanged',
  PASSPORT_DATE_ISSUE: 'passportDateIssue',
  PASSPORT_ISSUER: 'passportIssuer',
  PASSPORT_ISSUER_CODE: 'passportIssuerCode',
  PASSPORT_SERIES_AND_NUMBER: 'passportSeriesAndNumber',

  PREVIOUS_PASSPORT_DATE_ISSUE: 'previousPassportDateIssue',
  PREVIOUS_PASSPORT_NUMBER: 'previousPassportNumber',
  PREVIOUS_PASSPORT_SERIES: 'previousPassportSeries',

  REGISTRATION_ADDRESS: 'registrationAddress',
  REGISTRATION_ADDRESS_FROM_DA_DATA: 'registrationAddressFromDaData',
};

export const STORE_FALLBACK = {
  [NAMES.LIVING_ADDRESS_FROM_DA_DATA]: true,
  [NAMES.MANUAL_LIVING_ADDRESS]: {},
  [NAMES.MANUAL_REGISTRATION_ADDRESS]: {},
  [NAMES.REGISTRATION_ADDRESS_FROM_DA_DATA]: true,
};
export const STORE_MAP = {
  [NAMES.BIRTH_PLACE]: FIELDS.BIRTH_PLACE,

  [NAMES.LIVING_ADDRESS]: FIELDS.LIVING_ADDRESS,
  [NAMES.LIVING_ADDRESS_EQUALS]: FIELDS.LIVING_ADDRESS_EQUALS,
  [NAMES.LIVING_ADDRESS_FROM_DA_DATA]: FIELDS.LIVING_ADDRESS_FROM_DA_DATA,

  [NAMES.MANUAL_LIVING_ADDRESS]: FIELDS.LIVING_ADDRESS_DA_DATA_INFO,
  [NAMES.MANUAL_REGISTRATION_ADDRESS]: FIELDS.REGISTRATION_ADDRESS_DA_DATA_INFO,

  [NAMES.PASSPORT_CHANGED]: FIELDS.PASSPORT_CHANGED,
  [NAMES.PASSPORT_DATE_ISSUE]: FIELDS.PASSPORT_ISSUE_DATE,
  [NAMES.PASSPORT_ISSUER]: FIELDS.PASSPORT_ISSUER,
  [NAMES.PASSPORT_ISSUER_CODE]: FIELDS.PASSPORT_ISSUER_CODE,
  [NAMES.PASSPORT_SERIES_AND_NUMBER]: FIELDS.PASSPORT_SERIES_AND_NUMBER,

  [NAMES.PREVIOUS_PASSPORT_DATE_ISSUE]: FIELDS.PREVIOUS_PASSPORT_ISSUE_DATE,
  [NAMES.PREVIOUS_PASSPORT_NUMBER]: FIELDS.PREVIOUS_PASSPORT_NUMBER,
  [NAMES.PREVIOUS_PASSPORT_SERIES]: FIELDS.PREVIOUS_PASSPORT_SERIES,

  [NAMES.REGISTRATION_ADDRESS]: FIELDS.REGISTRATION_ADDRESS,
  [NAMES.REGISTRATION_ADDRESS_FROM_DA_DATA]: FIELDS.REGISTRATION_ADDRESS_FROM_DA_DATA,
};

export const ADDRESS_TYPES = {
  LIVING: 'living',
  REGISTRATION: 'registration',
};
export const ADDRESS_HANDLER_MAP = {
  [ADDRESS_TYPES.LIVING]: {
    [ADDRESS_HANDLER_KEYS.ADDRESS]: STORE_MAP[NAMES.LIVING_ADDRESS],
    [ADDRESS_HANDLER_KEYS.DA_DATA]: STORE_MAP[NAMES.MANUAL_LIVING_ADDRESS],
    [ADDRESS_HANDLER_KEYS.IS_DA_DATA]: STORE_MAP[NAMES.LIVING_ADDRESS_FROM_DA_DATA],
  },
  [ADDRESS_TYPES.REGISTRATION]: {
    [ADDRESS_HANDLER_KEYS.ADDRESS]: STORE_MAP[NAMES.REGISTRATION_ADDRESS],
    [ADDRESS_HANDLER_KEYS.DA_DATA]: STORE_MAP[NAMES.MANUAL_REGISTRATION_ADDRESS],
    [ADDRESS_HANDLER_KEYS.IS_DA_DATA]: STORE_MAP[NAMES.REGISTRATION_ADDRESS_FROM_DA_DATA],
    [ADDRESS_HANDLER_KEYS.POSTAL_CODE]: FIELDS.REGISTRATION_INDEX,
  },
};

export const DEFAULT_VALUES = Object.values(NAMES).reduce(
  (acc, key) => {
    acc[key] ??= '';

    return acc;
  },
  {
    [NAMES.MANUAL_LIVING_ADDRESS]: {},
    [NAMES.MANUAL_REGISTRATION_ADDRESS]: {},
    [NAMES.REGISTRATION_ADDRESS_FROM_DA_DATA]: true,
  }
);
